import { List, ListItem, ListItemText, Stack, Typography } from "@mui/material";
import { formatInstallationDate } from "@utils/dateFormat";
import { useStyle } from "@features/confirmation/style";
import { useTranslation } from "react-i18next";
import { DateChange } from "@features/confirmation/components/DateChange";

interface IParams {
    activationAt: Date;
}

export const ConfirmationNoInstall = (props: IParams) => {
    const { activationAt } = props;
    const { t } = useTranslation("confirmation");

    const { classes } = useStyle();

    return (
        <Stack spacing={2}>
            <Typography color="secondary" component="p" gutterBottom variant="normal">
                {t("noInstallInfo")}
            </Typography>
            <Typography color="secondary" component="p" gutterBottom variant="normal">
                {t("activationDate")}
            </Typography>
            <div className={classes.installationDate}>
                <Typography color="secondary" variant="normal">
                    {formatInstallationDate(new Date(activationAt))}
                </Typography>
            </div>
            <Typography color="secondary" variant="normal">
                {t("noInstallSetUp")}
            </Typography>
            <List className={classes.list}>
                <ListItem className={classes.listItem}>
                    <ListItemText primary={<DateChange />} />
                </ListItem>
                <ListItem className={classes.listItem}>
                    <ListItemText primary={t("noInstallEquipment")} />
                </ListItem>
            </List>
        </Stack>
    );
};
